import respond from './utilities/respond'
import at from '../../actionTypes'
import errorTypes from '../../../enums/errorTypes'
import { localisedError } from '../../../utilities/Errors'
import that from '../../../utilities/translationHelper'
import { fetchFatalError } from './fetchActions'
import getUserProfile from '../../../dataservices/getUserProfile'

const userProfilePublicActions = {
	userProfilePublicFetchBegin: value => respond(at.userProfilePublic.fetch.BEGIN, { value }),
	userProfilePublicFetchSuccess: dispatch => userProfilePublic => respond.promise(dispatch, at.userProfilePublic.fetch.SUCCESS, { userProfilePublic }),
	userProfilePublicFetchFail: error => respond(at.userProfilePublic.fetch.FAIL, { error }),
	userProfilePublicFetch: dispatch => (userName) => {
		dispatch(userProfilePublicActions.userProfilePublicFetchBegin(userName))
		return getUserProfile({ userName, fromPublic: true })
			.then(({ userProfile }) => {
				userProfilePublicActions.userProfilePublicFetchSuccess(dispatch)(userProfile)
			})
			.catch((error) => {
				//	We can handle this error gracefully
				if (error && (error.type === errorTypes.NOTFOUND || error.error === errorTypes.NOTFOUND)) {
					return dispatch(userProfilePublicActions.userProfilePublicFetchFail(localisedError(that.context.translate('Could not find user {userName}', { userName })), userName))
				}
				return dispatch(fetchFatalError(error))
			})
	}
}

export default userProfilePublicActions



// WEBPACK FOOTER //
// ./src/redux/actionCreators/old_actions/userProfilePublicActions.js